/**
 * Urban Network Module (Red Urbana)
 *
 * @version 2.0
 * @updated 2026-03-04
 * @module core/modules/vias
 *
 * @description
 * Módulo de Red Urbana - infraestructura base de circulación.
 * Sistema nervioso de la plataforma que gestiona:
 *   - Red vial canónica (nodos y segmentos)
 *   - Topología de calles e intersecciones
 *   - Atributos físicos y operacionales
 *   - Visualización multi-vista (jerarquía, sintaxis, servicios)
 *   - Edición interactiva de la red
 *
 * @remarks
 * **Auto-registro**:
 * Este módulo se auto-registra en el moduleRegistry al importarse.
 * No requiere modificar MapLayout, BottomToolbar ni ningún componente core.
 *
 * **Nota**: Este módulo es infraestructura base, no un módulo operativo.
 * Todos los módulos de movimiento (waste, mobility, emergencias) consumen esta red.
 */

import { moduleRegistry } from '../../module-registry';
import { UrbanNetworkTabbedPanel } from '../../layouts/panels/LeftPanel';
import { ViasToolbarContent } from './components';

// Types
export * from './types';

// Constants
export * from './constants';

// Store
export {
  useViasUIStore,
  selectViasSelection,
  selectViasHasSelection,
  selectViasRightView,
  type ViasUIStore,
  type ViasUIState,
  type ViasUIActions,
  type ViasSelection,
  type ViasSelectionType,
} from './store';

// Components
export { ViasToolbarContent } from './components';

/* ===== AUTO-REGISTRO DEL MÓDULO ===== */

/**
 * Registra el módulo Red Urbana (Urban Network) en el registry.
 *
 * @remarks
 * - id: 'urban-network' (antes 'vias')
 * - leftPanel: UrbanNetworkTabbedPanel (2 pestañas: Edges y Nodos + Panel de control)
 * - toolbar: ViasToolbarContent (herramientas de visualización + edición)
 * - Sin provider: contextos de red urbana se gestionan globalmente (UrbanNetworkContext)
 * - enabledByDefault: true (coherente con el módulo core activo al arrancar)
 */
moduleRegistry.register({
  id: 'urban-network',
  leftPanel: UrbanNetworkTabbedPanel,
  toolbar: {
    content: ViasToolbarContent,
  },
  requiresRealtime: false,
  enabledByDefault: true,
});
